import React from 'react';
import {
    Show,
    TabbedShowLayout,
    Tab,
    TextField,
    ArrayField,
    Datagrid,
    useRecordContext,
} from 'react-admin';

const SelectOptions = () => {
    const record = useRecordContext();
    if (record?.type !== 'select') return null;
    return (
        <ArrayField source="options" label="Opciones">
            <Datagrid bulkActionButtons={false} sx={{ width: 'auto' }}>
                <TextField source="display_name" label="Nombre de opción" />
            </Datagrid>
        </ArrayField>
    );
};

const CustomFieldShow = () => (
    <Show>
        <TabbedShowLayout>
            <Tab label="summary">
                <TextField source="id" />
                <TextField source="client.name" label="Cliente" />
                <TextField source="name" />
                <TextField source="slug" />
                <TextField source="type" />
                <SelectOptions />
            </Tab>
        </TabbedShowLayout>
    </Show>
);

export default CustomFieldShow;
